import {
  Coordinates,
  Subtopic
} from '@shared/domain/subtopic/subtopic.aggregate';
import { Survey } from '@shared/domain/survey/survey.aggregate';

export interface SubtopicDto {
  id: number;
  name: string;
  topicName: string;
  nameLanguage: string;
  topicId: number;
  topicNameLanguage: string;
  descriptionLanguage: string;
  position: Coordinates;
  survey: Survey;
  contents: number[];
}

export const toSubtopicDomainEntity = (
  incommingSubtopic: SubtopicDto
): Subtopic => {
  return {
    id: incommingSubtopic.id,
    name: incommingSubtopic.name,
    nameLanguage: incommingSubtopic.nameLanguage,
    topicId: incommingSubtopic.topicId,
    topicName: incommingSubtopic.topicName,
    topicNameLanguage: incommingSubtopic.topicNameLanguage,
    descriptionLanguage: incommingSubtopic.descriptionLanguage,
    position: incommingSubtopic.position,
    survey: incommingSubtopic.survey,
    contents: incommingSubtopic.contents
  };
};
